import { LIMIT_MAX } from '@/constants';
import { fetcher } from '@/services/graphql/fetcher/index';
import { Sort, type AnyObj } from '@/types';
import { fetchHotWordsDocument, fetchProductListOptionsDocument } from '../graphql/docs';

/**
 * 搜索热词
 */
export const fetchSearchHotWords = async () => {
  const res = await fetcher.query(fetchHotWordsDocument, {
    variables: {
      options: {
        take: LIMIT_MAX,
        sort: {
          createdAt: Sort.DESC,
        },
      },
    },
  });
  return res.data.value?.hotWords?.items;
};

/**
 * 搜索结果
 * @param variables
 */
export const fetchSearchResult = async (variables: AnyObj) => {
  const res = await fetcher.query(fetchProductListOptionsDocument, {
    variables,
  });
  return res.data.value?.products?.items;
};
